import React,{useContext} from 'react';
import { Navigate,useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext'; // Assuming you have an AuthContext for managing authentication

const ProtectedRoutes = ({ children }) => {
  const { token } = useContext(AuthContext)  
  const location=useLocation()
  if (!token) {
    // If the user is not authenticated, redirect them to the login page
    return <Navigate to="/loginUser" state={{from:location}} replace />;
  }

  // If authenticated, render the children components
  return children;
};

export default ProtectedRoutes;
